<template>
  <div>
    <div class="app-downlord _mb-md-20">
      <div v-if="payback" class="img-box _mb-sm-25">
        <img
          src="@/assets/images/common/appdownlord/app_preview-sv029.jpg"
          class="phone img-fluid"
          alt=""
        />
      </div>
      <div v-else class="img-box _mb-sm-25">
        <img
          src="@/assets/images/common/appdownlord/app_preview.jpg"
          class="phone img-fluid"
          alt=""
        />
      </div>
      <div class="right-box _ml-md-20">
        <div class="iphone-box _mb-md-20 _mb-sm-20">
          <p class="ttl">iPhone をお持ちの方</p>
          <p class="txt01">
            iPhone端末向け<br class="-pcnone" />ダウンロードサイト
          </p>
          <div class="iphone">
            <a
              href="https://itunes.apple.com/jp/app/id1455810848?mt=8"
              target="_blank"
              ><img
                src="@/assets/images/common/appdownlord/iphone.gif"
                class="img-fluid"
                alt=""
            /></a>
          </div>
        </div>
        <div class="android-box _mb-sm-20">
          <p class="ttl">Android をお持ちの方</p>
          <p class="txt01">
            Android端末向け<br class="-pcnone" />ダウンロードサイト
          </p>
          <div class="android">
            <a
              href="https://play.google.com/store/apps/details?id=com.kddi_fs.smartloan"
              target="_blank"
              ><img
                src="@/assets/images/common/appdownlord/android.gif"
                class="img-fluid"
                alt=""
            /></a>
          </div>
        </div>
      </div>
    </div>

    <ListGroup class="-normal">
      <ListItem class="-normal"
        >Android OS 10 以上を搭載した端末、iOS 15 以上を搭載した端末</ListItem
      >
      <ListItem class="-normal"
        >「iPhone」「iOS」「App Store」は、米国および他の国々で登録されたApple
        Inc.の商標です。</ListItem
      >
      <ListItem class="-normal"
        >「Android」「Google Play」はGoogle
        Inc.の商標または登録商標です。</ListItem
      >
    </ListGroup>
  </div>
</template>

<script>
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
export default {
  name: "AppDownlord",
  components: {
    ListItem,
    ListGroup,
  },
  props: {
    payback: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.app-downlord {
  @include mq-up(md) {
    display: flex;
    align-items: center;
  }
  > .img-box {
    text-align: center;
    @include mq-up(md) {
      width: 50%;
    }
    > .phone {
      max-width: 235px;
      width: 100%;
      @include mq-up(md) {
        max-width: 472px;
      }
    }
  }
  > .right-box {
    @include mq-up(md) {
      width: 50%;
    }
    .iphone-box,
    .android-box {
      display: flex;
      align-items: center;
      border: 1px solid $secondary;
      flex-wrap: wrap;
      border-radius: 10px;
      padding: 20px 30px;
      @include mq-up(md) {
        padding: 30px 50px;
      }
      > .ttl {
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        color: $orange;
        text-align: center;
        @include mq-up(md) {
          font-size: 24px;
        }
      }
      > .txt01 {
        width: 50%;
        @include mq-down(md) {
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 0;
        }
        @include mq-up(md) {
          width: 58%;
        }
      }
      > .iphone {
        width: 100%;
        @include mq-down(md) {
          width: 50%;
        }
        @include mq-up(md) {
          max-width: 166px;
        }
      }
      > .android {
        width: 100%;
        @include mq-down(md) {
          width: 50%;
        }
        @include mq-up(md) {
          max-width: 202px;
        }
      }
    }
  }
}
</style>
